import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import TitlePage from '../../../../components/TitlePage';
import { useNavigate, useParams } from 'react-router-dom';
import WizardSteps from '../../../../components/WizardSteps/Wizard';
import Step from '../../../../components/WizardSteps/Steps';
import SubmitForm from '../../../../components/SubmitForm';
import FormularioCRM from '../Formulario';
import { ConsultaAPI } from '../../../../../backend/ConsultaAPI';

import ConsultaCategorias from '../../../../../lib/json/consultas/Categorias.json'
import ConsultaProcessosCRM from '../../../../../lib/json/consultas/ProcessosCRM.json'
import ConsultaFormProcessoCRM from '../../../../../lib/json/consultas/FormProcessoCRM.json'
import LoadingSpinner from '../../../../components/LoadinSpinner';

function FichaProcessos() {
    const navigate = useNavigate();
    const [carregar, setCarregar] = useState(true);
    const [steps, setSteps] = useState([]);
    const [stepIndex, setStepIndex] = useState(0);
    const [isInclusao, setIsInclusao] = useState(false);
    const [titlePage, setTitlePage] = useState('Processos CRM');
        
    var categoriaWizard;
    
    const { idProcesso } = useParams();

    useEffect(() => {
        if (idProcesso){
            loadProcessos();
        }else{
            renderSteps( 0, 0 );
        }
    }, []);

    const loadProcessos = async() => {
        //Busca a Primeira Categoria para fazer a Criação da Tela
        let consultaProcessoCRM = ConsultaProcessosCRM.consulta + ` WHERE Id = ${idProcesso} `;
        let retProcessoCRM = await ConsultaAPI(consultaProcessoCRM);

        if (retProcessoCRM.data) {    
            categoriaWizard = retProcessoCRM.data[0].CategoriaId;
            
            renderSteps( retProcessoCRM.data[0].IdOrigem, retProcessoCRM.data[0].EtapaAtual, retProcessoCRM.data[0].RevisaoComercial, retProcessoCRM.data[0].RevisaoTecnica )
        }
    }

    const renderSteps = async (idOrigem, etapaAtual, revisaoComercial, revisaoTecnica) => {
        if (!categoriaWizard){
            setIsInclusao(true);

            //Busca a Primeira Categoria para fazer a Criação da Tela
            let consultaCategoria = ConsultaCategorias.consulta + " WHERE Ordem = 1 ";
            let retCategoria = await ConsultaAPI(consultaCategoria);
    
            if (retCategoria.data) {    
                categoriaWizard = retCategoria.data[0].Id;
            }
        }

        if (categoriaWizard){
            let consultaFormulario = ConsultaFormProcessoCRM.consulta + ` AND RevisaoComercial = '${revisaoComercial}' AND RevisaoTecnica = '${revisaoTecnica}' AND IdOrigem = '${idOrigem}' WHERE CategoriasId = '${categoriaWizard}' AND EtapasId IS NOT NULL`;
            let retConsulta = await ConsultaAPI(consultaFormulario);
    
            if (retConsulta.data) {
                let dados = retConsulta.data;
                
                if (etapaAtual){
                    dados.forEach((item, index) => {
                        if(item.EtapasId === etapaAtual){
                            setStepIndex(index)
                        }
                    })
                }

                setSteps(dados);
                setTitlePage(dados[0].CategoriasDescricao.trim());
            }

            setCarregar(false);
        }
    }

    

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar} />
                <Col md="12" xs="12">
                    <TitlePage text={titlePage} />
                </Col>
            </Row>
                <div className="App">
                {/* Aqui Vai Ficar Renderizado os Dados De Origem */}
                    {steps.length > 0 ? (
                        <WizardSteps initialStep={stepIndex}>
                            {steps.map((step, index) => {
                                return ( 
                                    <Step key={step.EtapasId} Title={step.EtapasDescricao} completed={step.Status === "E"} etapaExist={step.IdProcesso}>
                                        <FormularioCRM 
                                            Id={step.IdProcesso || 0}
                                            IdOrigem={step.IdOrigem || 0}
                                            CategoriaId={step.CategoriasId}
                                            EtapaId={step.EtapasId} 
                                            FormIndice={index}
                                            FormAtual={step.Status === "A" || isInclusao ? stepIndex : -1}
                                            Etapas={steps}
                                            FormInclusao={isInclusao}
                                            onHanldeStep={setStepIndex}
                                            onHandleInclusao={setIsInclusao}
                                        />
                                    </Step>
                            )})}
                            </WizardSteps>
                    ) : (
                        <p>No steps available</p>
                    )}
                    <SubmitForm onVoltar={"handleCancelar"}></SubmitForm>
                </div>
        </>
    );
}

export default FichaProcessos;
